import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const SearchSectionStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "search-section",
})`
  background: ${greyMui._50};
  border: 1px solid ${greyMui._200};
  border-radius: 8px;
  padding: 16px;
  margin: 4px 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .search-section__content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .search-section__search {
    flex: 1;
    min-width: 0;

    &--key {
      padding-inline-start: 12px;
      border-inline-start: 1px solid ${greyMui._200};
    }

    .MuiTextField-root {
      width: 100%;
    }

    .MuiInput-underline:before {
      border-bottom: 1px solid ${greyMui._300};
      width: 100%;
    }

    .MuiInput-underline:after {
      border-bottom: 2px solid ${greyMui._500};
      width: 100%;
    }

    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom: 1px solid ${greyMui._400};
      width: 100%;
    }
  }

  .search-section__actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .search-section__action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    background: ${rydeColors.white};
    color: ${greyMui._500};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${greyMui._50};
      border-color: ${greyMui._400};
      color: ${greyMui._700};
    }

    &:active {
      background: ${greyMui._100};
      transform: translateY(1px);
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .search-section__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
    margin-top: 12px;
  }

  .search-section__filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-section__summary {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-inline-start: auto;
  }

  .search-section__counter {
    color: ${greyMui._700};
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }

  .search-section__export {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px 4px 12px;
    border: 1px solid ${greyMui._300};
    border-radius: 16px;
    background: ${rydeColors.white};
    color: ${greyMui._700};
    font-size: 12px;
    cursor: pointer;

    &:hover {
      background: ${greyMui._100};
      border-color: ${greyMui._400};
    }

    &:focus-visible {
      outline: 2px solid ${rydeColors.focusedControl};
      outline-offset: 2px;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .search-section__filter {
    padding: 4px 12px;
    border: 1px solid ${greyMui._300};
    border-radius: 16px;
    background: ${rydeColors.white};
    color: ${greyMui._700};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${greyMui._100};
    }

    &:focus-visible {
      outline: 2px solid ${rydeColors.focusedControl};
      outline-offset: 2px;
    }

    &--empty {
      opacity: 0.55;
    }

    &[aria-pressed="true"] {
      font-weight: 600;
      color: ${rydeColors.white};
    }

    &--added[aria-pressed="true"] {
      background: ${rydeColors.green};
      border-color: ${rydeColors.green};
    }

    &--removed[aria-pressed="true"] {
      background: ${rydeColors.brandRed};
      border-color: ${rydeColors.brandRed};
    }

    &--changed[aria-pressed="true"] {
      background: ${rydeColors.steel};
      border-color: ${rydeColors.steel};
    }

    &--reordered[aria-pressed="true"] {
      background: ${rydeColors.passOutOrange};
      border-color: ${rydeColors.passOutOrange};
    }
  }

  .search-section__filter-count {
    margin-inline-start: 6px;
    font-variant-numeric: tabular-nums;
    opacity: 0.8;
  }

  .search-section__checkbox {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid ${greyMui._200};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .search-section__checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    color: ${greyMui._700};
    user-select: none;

    &:hover {
      color: ${greyMui._900};
    }
  }

  .search-section__checkbox-input {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: ${greyMui._600};
  }

  .search-section__checkbox-text {
    font-weight: 500;
  }

  .search-section__footer-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .search-section__footer-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid ${greyMui._300};
    border-radius: 6px;
    background: ${rydeColors.white};
    color: ${greyMui._600};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${greyMui._50};
      border-color: ${greyMui._400};
      color: ${greyMui._700};
    }

    &:active {
      background: ${greyMui._100};
      transform: translateY(1px);
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;
